<template>
  <div>
    <!-- Table Container Card -->
    <!-- <div class="">
      <b-tabs card> -->

        
        <!-- <b-tab no-body title="Kanban Board">
          <LeadKanban />
        </b-tab> -->
      <!-- </b-tabs>
    </div> -->
    <TableList />
  </div>
</template>

<script>
import TableList from "./TableList.vue";
import LeadKanban from "./LeadKanban";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardImg,
  BCardFooter,
  BModal,
  VBModal,
  BTabs,
  BTab,
} from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {
    TableList,
    LeadKanban,
    BModal,
    vSelect,
    BCard,
    BCardImg,
    BCardFooter,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTabs,
    BTab,
  },
  data() {
    return {
      isActive: true,
      perPage: 10,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
